import React from 'react';
import { painPoints } from '../data/kit';
export function PainPointsSection() {
  return <section className="py-20 px-4 bg-brand-creamAlt" data-id="element-105" data-mp="2hsae1j41nez9">
      <div className="max-w-3xl mx-auto text-center" data-id="element-106" data-mp="2htlk5pkyoytj">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-4" data-id="element-107" data-mp="2wpb5rmm8j9xq">
          ¿Te reconocés en estas escenas?
        </h2>
        <p className="text-brand-gray mb-12" data-id="element-108" data-mp="2rodhcsamtjns">
          Si respondés que sí a una sola, este pack es para vos.
        </p>

        <ul className="space-y-4 mb-12" data-id="element-109" data-mp="35nd2hpyxrgf7">
          {painPoints.map((point, i) => <li key={point} className="bg-white rounded-2xl p-6 shadow-sm flex items-center gap-5 text-left border border-brand-creamDark/50" data-id="element-110" data-mp="30ok0atp3nbuc" data-mpi={i}>
              <span aria-hidden="true" className="font-serif font-bold text-2xl text-brand-terracottaText/70 shrink-0 w-8 text-center" data-id="element-111" data-mp="3agy3lqvtsqim">
                {i + 1}
              </span>
              <span className="text-brand-text font-medium md:text-lg" data-id="element-112" data-mp="3kcssh3qn7htu">
                {point}
              </span>
            </li>)}
        </ul>

        <p className="text-xl md:text-2xl font-serif italic text-brand-greenDeep font-bold" data-id="element-113" data-mp="wx4tp5oj7hte">
          Tu trabajo vale mucho más que eso →
        </p>
      </div>
    </section>;
}